// extracted by mini-css-extract-plugin
export default {"mobile-only-button":"styles_mobile-only-button__JpfB-","form-with-sidebar-wrapper":"styles_form-with-sidebar-wrapper__DI8CX"};